import type { PresentationModule } from '../../presentation/types';
import { technology } from './content';
import { TechnologyScene } from './scenes/TechnologyScene';

export const technologyModule: PresentationModule = {
  id: 'technology',
  label: 'The invisible technology',
  priority: 'structural',
  scenes: [
    { ...technology, module: 'technology', create: (resolved) => new TechnologyScene(resolved) },
  ],
};
